module.exports = __webpack_public_path__ + "static/media/top-img_7.c951e130.jpg";